import React from 'react'
import SingleBlog from '../components/blog/singleBlog'

import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'


const SingleBlogPage = () => {
    return (
        <>
            <Navbar />
            <SingleBlog />
            <Footer />
        </>
    )
}

export default SingleBlogPage